module.exports = __webpack_public_path__ + "static/media/Munin.67a7956d.gif";